import {useCallback} from 'react'
import {useNavigate} from 'react-router'

const BASE_PATH = '/connect_expense_account'

const FLOW = ['information', 'select_account', 'confirmation']

export const isLastStep = (step) => {
  return FLOW.at(-1) === step
}

const getNextStepRoute = (currentStep) => {
  if (currentStep === 'connect_expense_account') {
    return `${BASE_PATH}/${FLOW[1]}`
  }

  const currentIndex = FLOW.indexOf(currentStep)
  const nextStep = FLOW[currentIndex + 1]

  if (!nextStep) return null

  return `${BASE_PATH}/${nextStep}`
}

const getPreviousStepRoute = (currentStep) => {
  const currentIndex = FLOW.indexOf(currentStep)
  const previousStep = FLOW[currentIndex - 1]

  if (!previousStep) return null

  return `${BASE_PATH}/${previousStep}`
}

const useStepNavigation = (currentStep) => {
  const navigate = useNavigate()

  const goToNextStep = useCallback(() => {
    const route = getNextStepRoute(currentStep)

    if (route) {
      navigate(route)
    }
  }, [currentStep, navigate])

  const goToPreviousStep = useCallback(() => {
    const route = getPreviousStepRoute(currentStep)

    if (route) {
      navigate(route)
    }
  }, [currentStep, navigate])

  const goToConfirmation = useCallback(() => {
    navigate('confirmation')
  }, [navigate])

  const goToDashboard = useCallback(() => {
    navigate('/dashboard')
  }, [navigate])

  const goToNotifyCustomers = useCallback(() => {
    navigate('/customers/transition_to_marmalade')
  }, [navigate])

  return {
    goToConfirmation,
    goToNextStep,
    goToPreviousStep,
    goToDashboard,
    goToNotifyCustomers,
  }
}

export default useStepNavigation
